<template>
  <Card
    variant="widget"
    tag="form"
    :title="$t('publishingOfThePage')"
    :subtitle="$t('publishingOfThePageSubtitle')"
    class="page-mutate-publishing"
    @submit.prevent="$emit('submit')"
  >
    <template #default>
      <div class="page-mutate-publishing__input">
        <FieldRenderer v-for="item in fields.default" :validator="validator" :item="item" :value="value" />
      </div>

      <CustomFields
        v-if="item.id"
        v-model="value.customFields"
        :schema="customFieldSchemas"
        :data="data"
        :placement="['publishing', 'page:publishing']"
        data-field="custom-fields"
        :validator="validator"
        validator-prefix="customFields"
        :disabledFields="$path('metadata.disabledFields.page', item)"
      >
        <template v-for="item in fields.slots" v-slot:[item.slotKey]>
          <FieldRenderer :validator="validator" :item="item" :value="value" />
        </template>
      </CustomFields>
    </template>
  </Card>
</template>

<script>
import { mapState } from 'vuex'
import Card from '@/components/Card-v2'
import { InputComponent } from 'vue-elder-input'
import { i18n } from '@/i18n'
import CustomFields from '@kvass/custom-fields'
import FieldRenderer from '@/components/Page/StepsFields/FieldRenderer.vue'

const meta = {
  order: 1006,
  id: 'publishing',
  label: i18n.tc('publishing'),
  icon: ['fal', 'globe'],
  fields: ['publishing.domain'],
}

export { meta }
export default {
  props: {
    data: Object,
    value: Object,
    labels: Object,
    isActive: Boolean,
    validator: Object,
    customFieldSchemas: { type: Array, default: () => [] },
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState('Page', {
      item(state) {
        return state.item && Object.keys(state.item).length ? state.item : this.data
      },
    }),
  },
  components: {
    Card,
    InputComponent,
    CustomFields,
    FieldRenderer,
  },
}
</script>

<style lang="scss">
.page-mutate-publishing {
  max-width: 800px;

  .card-v2__subtitle {
    margin-top: 1rem;
  }
}
</style>
